import style from '../../../shared/components/layout/Slider/SliderCarousel.module.css'
function Circle(){
    return(
        <svg className={style.IndicatorsIcon}>
            <circle cx="7" cy="7" r="7" />
        </svg> 
    )
}
export default Circle